import VueCookie from 'vue-cookie';
import axios, { AxiosInstance } from 'axios';
import { ENDPOINTS } from '@/settings/endpoints';

export interface CollaborationResponse<T> {
  data: T;
  message: string;
  identifier: string;
}

export interface TrialUserDto {
  courseId: string;
  courseName: string;
  email: string;
  enrollmentWindowId: string;
  enrollmentWindowName: string;
  isActive: boolean;
  profileId: number;
  studyWindowId: string;
  studyWindowName: string;
  trialEndDate: string;
  trialStartDate: string;
  currentServerDate: string;
}

export class TrialService {
  private gateway: AxiosInstance;

  private readonly dexToken: string | null;

  constructor() {
    const tokenD = VueCookie.get('d', { domain: '.descomplica.com.br' });

    this.gateway = axios.create({
      baseURL: `${ENDPOINTS.pegasusSilver}undergrad/trial`,
      timeout: 10000,
      headers: {
        Authorization: `Bearer ${tokenD}`,
      },
    });
  }

  async getTrialUser(email: string): Promise<TrialUserDto> {
    const {
      data: { data },
    } = await this.gateway.get<CollaborationResponse<TrialUserDto>>(`/get-user/?email=${email}`);

    return data;
  }

  async removeUserAccess(
    email: string,
    courseId: string,
    profileId: string | Number | null,
  ): Promise<TrialUserDto> {
    const {
      data: { data },
    } = await this.gateway.post<CollaborationResponse<TrialUserDto>>(
      `/remove-user-different-course`,
      {
        email,
        courseId,
        profileId,
      },
    );
    return data;
  }
}
